module.exports = __webpack_public_path__ + "img/i_coupon_s_gr.58c494e8.svg";